import "../../../assets/scss/machine-card-style.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Empty, Modal, Skeleton } from "antd";
import { useAppSelector } from "../../store/hooks";
import { MachineCard } from "../../components/machineCard";
import { MachineCardInterface } from "../../utility/interface/machine-card";
import { ProviderMachineCard } from "../../components/ProviderMachineCard";
import {
  AddMachineSelectionList,
  ProviderHostItem,
} from "../../components/AddMachineSelectionList";
import { ProviderSchedulesTable } from "../../components/ProviderSchedulesTable";
import { getProviderHosts } from "../../server/Provider";

import { SyncOutlined } from "@ant-design/icons";

export const MachineStatus = () => {
  const { t } = useTranslation();
  const providerStatusState = useAppSelector(
    (state: any) => state.providerStatus.data,
  );
  const providerLastUpdateTime = useAppSelector(
    (state: any) => state.providerStatus.lastUpdatedTime,
  );
  const providerStatusLoadingState = useAppSelector(
    (state: any) => state.providerStatus.loading,
  );
  const websocketStatus = useAppSelector(
    (state: any) => state.providerStatus.websocketStatus,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [providerMachineList, setProviderMachineList] = useState<any>("");
  const [addMachineModal, setAddMachineModal] = useState(false);
  const [availableHosts, setAvailableHosts] = useState<ProviderHostItem[]>([]);
  const [availableHostsLoading, setAvailableHostsLoading] = useState(false);
  const [scheduleRefreshTick, setScheduleRefreshTick] = useState(0);

  const fetchAvailableHosts = async (retryCount = 0): Promise<void> => {
    const MAX_RETRIES = 1;
    const RETRY_DELAY = 500;

    // Only set loading on the initial call
    if (retryCount === 0) {
      setAvailableHostsLoading(true);
    }

    try {
      const response = await getProviderHosts();
      const data = response.data;
      if (data.hosts) {
        setAvailableHosts(data.hosts);
      } else {
        setAvailableHosts([]);
      }
      setAvailableHostsLoading(false);
    } catch (err: any) {
      console.error("Failed to fetch available hosts:", err);

      // If we got a 401 and haven't exhausted retries, wait and retry
      // This handles the case where token refresh happens but the original call fails
      if (err?.response?.status === 401 && retryCount < MAX_RETRIES) {
        await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
        return fetchAvailableHosts(retryCount + 1);
      }

      setAvailableHosts([]);
      setAvailableHostsLoading(false);
    }
  };

  const openAddMachineModal = () => {
    setAddMachineModal(true);
    fetchAvailableHosts();
  };

  const handleCancel = () => setAddMachineModal(false);

  const handleInstallSuccess = () => {
    setAddMachineModal(false);
    window.location.reload();
  };

  useEffect(() => {
    if (providerStatusState.hosts) {
      setProviderMachineList(providerStatusState.hosts);
      setLoading(false);
      console.log("providerMachineList", providerMachineList);
    }
  }, [providerStatusState, websocketStatus]);

  useEffect(() => {}, []);

  return (
    <>
      <div className="top-action-bar">
        {websocketStatus == "error" ? (
          <></>
        ) : (
          <div className="top-action">
            <div className="last-updated">
              {t("Last Updated")}: &nbsp;
              <span style={{ color: "#000" }}>
                {providerLastUpdateTime} &nbsp;
              </span>
              <SyncOutlined
                onClick={() => window.location.reload()}
                style={{ color: "#000" }}
              />
            </div>
            <button className="primary-btn" onClick={openAddMachineModal}>
              {t("Add Machine")}
            </button>
          </div>
        )}
      </div>
      {(websocketStatus === "connected" || websocketStatus === "closed") && (
        <>
          {providerMachineList.length > 0 ? (
            <div className="machine-card-container">
              {providerMachineList.map((item: any) => {
                return (
                  <ProviderMachineCard
                    key={item.host_id}
                    host_id={item.host_id}
                    status={item.status}
                    node_name={item.node_name}
                    product_name={item.product_name}
                    gpu_type={item.gpu_type}
                    gpu_total={item.gpu_total}
                    gpu_in_use={item.gpu_in_use}
                    core_utilization={item.core_utilization}
                    memory_utilization={item.memory_utilization}
                    disk_utilization={item.disk_utilization}
                    network_receive={item.network_receive}
                    network_transmit={item.network_transmit}
                    gpu_live_report={item.gpu_live_report}
                    onScheduleCreated={() => setScheduleRefreshTick(prev => prev + 1)}
                  />
                );
              })}
            </div>
          ) : (
            <>
              {providerStatusLoadingState == true ? (
                <Skeleton active />
              ) : (
                <>
                  {websocketStatus !== "closed" &&
                    websocketStatus !== "error" && <Empty />}
                  {websocketStatus === "error" && <>An error has occured</>}
                </>
              )}
            </>
          )}
          
          <ProviderSchedulesTable refreshTick={scheduleRefreshTick} />
        </>
      )}

      <Modal
        title={null}
        open={addMachineModal}
        footer={null}
        onCancel={handleCancel}
        width="75%"
        centered
        destroyOnClose
        className="recharge-modal"
      >
        <AddMachineSelectionList
          hosts={availableHosts}
          loading={availableHostsLoading}
          onInstallSuccess={handleInstallSuccess}
        />
      </Modal>
    </>
  );
};
